import React from 'react'
import { View, Text, Font } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import { themeConfig } from '../../config/theme.config'

const LeftSectionTitle = ({ leftTitle, width }) => {
  const boxLeft = {
    width,
    borderRight: '1 solid grey',
    borderTop: '1 solid grey',
    borderLeft: '1 solid grey',
    padding: '5pt',
    backgroundColor: themeConfig.semcogBlue1,
    color: 'white',
    display: 'flex',
    fontSize: 12,
    justifyContent: 'center',
    fontFamily: 'Roboto',
    fontWeight: 'bold'
  }
  //   const text = { padding: '5pt' };
  return (
    <View style={[boxLeft]} wrap={false}>
      <Text>{leftTitle}</Text>
    </View>
  )
}

export default LeftSectionTitle

LeftSectionTitle.propTypes = {
  leftTitle: PropTypes.string.isRequired,
  width: PropTypes.string
}
